import React, {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import Collapse from '@mui/material/Collapse';

import {
  ColorContext,
  DataContext,
} from '../../../../../../contexts';

import AbasContext from '../../../../../Abas/assets/AbasContext';

import { RadioButton } from '../../../../..';

import WindowStorage from '../../../../../../utils/storage';

import { chaveExisteEm } from '../../../../../../utils';

import {
  RegraGradiente,
  RegraEscalaCores,
  RegraGradientePorFiltro,
  RegraEscalaPorFiltro,
} from '../RegrasDeCores';

import ActionsDialogoCores from '../ActionsDialogCores';

import {
  ConteinerRegrasCores,
  PendenteAplicar
} from '../../styles';

const ESCALA_CORES_INICIAL = [{
  id: 1,
  cor: '#0B8209',
  de: 1,
  ate: Number.MAX_VALUE,
}];

const POR_FILTRO_INICIAL = [{
  id: 1,
  cor: '#0B8209',
  item: '',
}];

const storageDialogoCores = WindowStorage.localStorage('dialogo-cores');

/*
  TODO: MELHORIA
  Migrar para componente para VisibilidadeSelecaoRadio
    - separa logica relacionada aos RadioButtons
    - minimiza estrutura JSX do componente
 */
function AbaColorirResultadoFiltro() {
  const { isSingleFilter } = useContext(DataContext);

  const { metodoColoracao } = useContext(ColorContext);

  const {
    abaAtual,
    criarPortalActions,
    dispatchStoreDialogoCores,
    onAplicar,
  } = useContext(AbasContext);

  const isAbaSelecionada = useMemo(() => abaAtual === 'aba-filtros', [abaAtual]);

  const [corGradiente, setCorGradiente] = useState(() => {
    const valorInicial = (
      storageDialogoCores.existe() && storageDialogoCores.get('corGradiente')
        ? storageDialogoCores.get('corGradiente')
        : '#0B8209'
    );
    dispatchStoreDialogoCores({ tipo: 'ALTERA', corGradiente: valorInicial });
    return valorInicial;
  });
  const [escalaCores, setEscalaCores] = useState(() => {
    const valorInicial = (
      storageDialogoCores.existe() && storageDialogoCores.get('escalaCores')
        ? storageDialogoCores.get('escalaCores')
        : ESCALA_CORES_INICIAL
    );
    dispatchStoreDialogoCores({ tipo: 'ALTERA', escalaCores: valorInicial });
    return valorInicial;
  });
  const [gradientePorFiltro, setGradientePorFiltro] = useState(() => {
    const valorInicial = (
      storageDialogoCores.existe() && storageDialogoCores.get('gradientePorFiltro')
        ? storageDialogoCores.get('gradientePorFiltro')
        : POR_FILTRO_INICIAL
    );
    dispatchStoreDialogoCores({ tipo: 'ALTERA', gradientePorFiltro: valorInicial });
    return valorInicial;
  });
  const [escalaPorFiltro, setEscalaPorFiltro] = useState(() => {
    const valorInicial = (
      storageDialogoCores.existe() && storageDialogoCores.get('escalaPorFiltro')
        ? storageDialogoCores.get('escalaPorFiltro')
        : POR_FILTRO_INICIAL
    );
    dispatchStoreDialogoCores({ tipo: 'ALTERA', escalaPorFiltro: valorInicial });
    return valorInicial;
  });

  const [tipoColoracaoFiltro, setTipoColoracaoFiltro] = useState(() => {
    const valorInicial = (
      storageDialogoCores.existe() && storageDialogoCores.get('tipoColoracaoFiltro')
        ? storageDialogoCores.get('tipoColoracaoFiltro')
        : 'radio-gradiente'
    );
    dispatchStoreDialogoCores({ tipo: 'ALTERA', tipoColoracaoFiltro: valorInicial });
    return valorInicial;
  });

  const alterarSelecaoRadio = useCallback((action) => {
    setTipoColoracaoFiltro(atual => {
      const novoValor = typeof action === 'function' ? action(atual) : action;
      dispatchStoreDialogoCores({ tipo: 'ALTERA', tipoColoracaoFiltro: novoValor });
      return novoValor;
    });
  }, [dispatchStoreDialogoCores]);

  const alterarCorGradiente = useCallback((action) => {
    setCorGradiente(atual => {
      const novoValor = typeof action === 'function' ? action(atual) : action;
      dispatchStoreDialogoCores({ tipo: 'ALTERA', corGradiente: novoValor });
      return novoValor;
    });
  }, [dispatchStoreDialogoCores]);

  const alterarEscalaCores = useCallback((action) => {
    setEscalaCores(atual => {
      const novoValor = typeof action === 'function' ? action(atual) : action;
      dispatchStoreDialogoCores({ tipo: 'ALTERA', escalaCores: novoValor });
      return novoValor;
    });
  }, [dispatchStoreDialogoCores]);

  const alterarGradientePorFiltro = useCallback((action) => {
    setGradientePorFiltro(atual => {
      const novoValor = typeof action === 'function' ? action(atual) : action;
      dispatchStoreDialogoCores({ tipo: 'ALTERA', gradientePorFiltro: novoValor });
      return novoValor;
    });
  }, [dispatchStoreDialogoCores]);

  const alterarEscalaPorFiltro = useCallback((action) => {
    setEscalaPorFiltro(atual => {
      const novoValor = typeof action === 'function' ? action(atual) : action;
      dispatchStoreDialogoCores({ tipo: 'ALTERA', escalaPorFiltro: novoValor });
      return novoValor;
    });
  }, [dispatchStoreDialogoCores]);

  useEffect(() => {
    if (metodoColoracao.tipo === 'gradiente') {
      alterarCorGradiente(metodoColoracao.cor);
      alterarSelecaoRadio('radio-gradiente');
    } else if (metodoColoracao.tipo === 'escala-cores') {
      alterarEscalaCores(
        metodoColoracao.regras
          .map(({ ate = Number.MAX_VALUE, ...resto }) => ({ ...resto, ate }))
      );
      alterarSelecaoRadio('radio-escala-cores');
    } else if (metodoColoracao.tipo === 'gradiente-por-filtro') {
      const regras = metodoColoracao.regras.map((item, index) => ({
        ...item,
        id: index + 1,
      }));

      alterarGradientePorFiltro(regras);
      alterarSelecaoRadio('radio-gradiente-por-filtro');
    } else if (metodoColoracao.tipo === 'escala-por-filtro') {
      const regras = metodoColoracao.regras.map((item, index) => ({
        ...item,
        id: index + 1,
      }));

      alterarEscalaPorFiltro(regras);
      alterarSelecaoRadio('radio-escala-por-filtro');
    }
  }, [
    alterarCorGradiente,
    alterarGradientePorFiltro,
    alterarEscalaPorFiltro,
    alterarEscalaCores,
    alterarSelecaoRadio,
    metodoColoracao.cor,
    metodoColoracao.regras,
    metodoColoracao.tipo
  ]);

  const [permitirAplicarEscala, setPermitirAplicarEscala] = useState(false);
  const [permitirAplicarGradientePorFiltro, setPermitirAplicarGradientePorFiltro] = useState(false);
  const [permitirAplicarEscalaPorFiltro, setPermitirAplicarEscalaPorFiltro] = useState(false);

  const aplicar = useCallback(() => {
    const novoMetodo = {};

    if (tipoColoracaoFiltro === 'radio-gradiente') {
      novoMetodo.tipo = 'gradiente';
      novoMetodo.cor = corGradiente;
    } else if (tipoColoracaoFiltro === 'radio-escala-cores') {
      novoMetodo.tipo = 'escala-cores';
      // garantir gerar novos objetos, não passar objetos como referencia
      novoMetodo.regras = escalaCores
        .map(({ ate = Number.MAX_VALUE, ...resto }) => ({ ...resto, ate }));
    } else if (tipoColoracaoFiltro === 'radio-gradiente-por-filtro') {
      novoMetodo.tipo = 'gradiente-por-filtro';
      novoMetodo.regras = gradientePorFiltro
        .map(({ desabilitar = false, ...resto }) => ({ ...resto, desabilitar }));
    } else if (tipoColoracaoFiltro === 'radio-escala-por-filtro') {
      novoMetodo.tipo = 'escala-por-filtro';
      novoMetodo.regras = escalaPorFiltro
        .map(({ desabilitar = false, ...resto }) => {
          const objeto = { ...resto, desabilitar };

          if (chaveExisteEm(resto, 'intervalo') && resto.intervalo) {
            objeto.intervalo = { ...resto.intervalo };
          }

          return objeto;
        });
    }

    onAplicar(novoMetodo);
  }, [
    escalaPorFiltro,
    gradientePorFiltro,
    escalaCores,
    corGradiente,
    onAplicar,
    tipoColoracaoFiltro
  ]);

  const regrasValidas = useMemo(() => {
    switch (tipoColoracaoFiltro) {
      case 'radio-gradiente': return true;
      case 'radio-escala-cores': return permitirAplicarEscala;
      case 'radio-gradiente-por-filtro': return permitirAplicarGradientePorFiltro;
      case 'radio-escala-por-filtro': return permitirAplicarEscalaPorFiltro;
      default: return false;
    }
  }, [
    permitirAplicarEscala,
    permitirAplicarGradientePorFiltro,
    permitirAplicarEscalaPorFiltro,
    tipoColoracaoFiltro
  ]);

  const faltaAplicarRegraGradiente = useMemo(() => (
    metodoColoracao.tipo !== 'gradiente'
    || metodoColoracao.cor !== corGradiente
  ), [metodoColoracao.tipo, metodoColoracao.cor, corGradiente]);

  const faltaAplicarRegraEscalaCores = useMemo(() => {
    if (metodoColoracao.tipo !== 'escala-cores') return true;
    if (metodoColoracao.regras.length !== escalaCores.length) return true;

    const todasRegrasEstaoAplicadas = metodoColoracao.regras.every(regra => {
      const temRegra = escalaCores.find(item => item.id === regra.id);
      if (!temRegra) return false;
      return Object.entries(temRegra)
        .every(([chave, valor]) => chave in regra && valor === regra[chave]);
    });

    return !todasRegrasEstaoAplicadas;
  }, [metodoColoracao.tipo, metodoColoracao.regras, escalaCores]);

  const faltaAplicarRegraGradientePorFiltro = useMemo(() => {
    if (metodoColoracao.tipo !== 'gradiente-por-filtro') return true;
    if (metodoColoracao.regras.length !== gradientePorFiltro.length) return true;

    const todasRegrasEstaoAplicadas = metodoColoracao.regras.every(regra => {
      const temRegra = gradientePorFiltro.find(item => item.id === regra.id);
      if (!temRegra) return false;
      return Object.entries(temRegra)
        .every(([chave, valor]) => chave in regra && valor === regra[chave]);
    });

    return !todasRegrasEstaoAplicadas;
  }, [metodoColoracao.tipo, metodoColoracao.regras, gradientePorFiltro]);

  const faltaAplicarRegraEscalaPorFiltro = useMemo(() => {
    if (metodoColoracao.tipo !== 'escala-por-filtro') return true;
    if (metodoColoracao.regras.length !== escalaPorFiltro.length) return true;

    const todasRegrasEstaoAplicadas = metodoColoracao.regras.every(regra => {
      const temRegra = escalaPorFiltro.find(item => item.id === regra.id);
      if (!temRegra) return false;
      return Object.entries(temRegra)
        .every(([chave, valor]) => (
          chave in regra && (
            chave === 'intervalo'
              ? valor.de === regra.intervalo.de && valor.ate === regra.intervalo.ate
              : valor === regra[chave]
          )
        ));
    });

    return !todasRegrasEstaoAplicadas;
  }, [metodoColoracao.tipo, metodoColoracao.regras, escalaPorFiltro]);

  return (
    <ConteinerRegrasCores
      value={tipoColoracaoFiltro}
      onChange={(e) => alterarSelecaoRadio(e.target.value)}
    >
      <RadioButton
        value="radio-gradiente"
        selected={tipoColoracaoFiltro === 'radio-gradiente'}
        disabled={!isSingleFilter}
      >
        Degradê
      </RadioButton>
      <Collapse in={tipoColoracaoFiltro === 'radio-gradiente'}>
        <RegraGradiente {...{ corGradiente, alterarCorGradiente }} />
      </Collapse>

      <RadioButton
        value="radio-escala-cores"
        selected={tipoColoracaoFiltro === 'radio-escala-cores'}
        disabled={!isSingleFilter}
      >
        Escala de Cores
      </RadioButton>
      <Collapse in={tipoColoracaoFiltro === 'radio-escala-cores'}>
        {
          escalaCores.map((regra, index) => (
            <RegraEscalaCores
              escalaCores={escalaCores}
              alterarEscalaCores={alterarEscalaCores}
              regra={regra}
              posicaoRegra={index}
              permitirAplicar={permitirAplicarEscala}
              setPermitirAplicar={setPermitirAplicarEscala}
            />
          ))
        }
      </Collapse>

      <RadioButton
        value="radio-gradiente-por-filtro"
        selected={tipoColoracaoFiltro === 'radio-gradiente-por-filtro'}
        disabled={isSingleFilter}
      >
        Degradê por Filtro
      </RadioButton>
      <Collapse in={tipoColoracaoFiltro === 'radio-gradiente-por-filtro'}>
        {
          gradientePorFiltro.map((regra, index) => (
            <RegraGradientePorFiltro
              gradientePorFiltro={gradientePorFiltro}
              alterarGradientePorFiltro={alterarGradientePorFiltro}
              regra={regra}
              posicaoRegra={index}
              permitirAplicar={permitirAplicarGradientePorFiltro}
              setPermitirAplicar={setPermitirAplicarGradientePorFiltro}
            />
          ))
        }
      </Collapse>

      <RadioButton
        value="radio-escala-por-filtro"
        selected={tipoColoracaoFiltro === 'radio-escala-por-filtro'}
        disabled={isSingleFilter}
      >
        Escala por Filtro
      </RadioButton>
      <Collapse in={tipoColoracaoFiltro === 'radio-escala-por-filtro'}>
        {
          escalaPorFiltro.map((regra, index) => (
            <RegraEscalaPorFiltro
              escalaPorFiltro={escalaPorFiltro}
              alterarEscalaPorFiltro={alterarEscalaPorFiltro}
              regra={regra}
              posicaoRegra={index}
              permitirAplicar={permitirAplicarEscalaPorFiltro}
              setPermitirAplicar={setPermitirAplicarEscalaPorFiltro}
            />
          ))
        }
      </Collapse>
      <PendenteAplicar>
        {
          (tipoColoracaoFiltro === 'radio-gradiente' && faltaAplicarRegraGradiente)
          && 'A cor selecionada ainda não foi aplicada'
        }
        {
          (tipoColoracaoFiltro === 'radio-escala-cores' && faltaAplicarRegraEscalaCores)
          && 'Existem regras selecionadas ainda não aplicadas'
        }
        {
          (tipoColoracaoFiltro === 'radio-gradiente-por-filtro' && faltaAplicarRegraGradientePorFiltro)
          && 'Existem regras selecionadas ainda não aplicadas'
        }
        {
          (tipoColoracaoFiltro === 'radio-escala-por-filtro' && faltaAplicarRegraEscalaPorFiltro)
          && 'Existem regras selecionadas ainda não aplicadas'
        }
      </PendenteAplicar>
      {
        isAbaSelecionada && (
          criarPortalActions(
            <ActionsDialogoCores
              aplicar={aplicar}
              permitirAplicar={regrasValidas}
            />
          )
        )
      }
    </ConteinerRegrasCores>
  );
}

export default memo(AbaColorirResultadoFiltro);
